const {
  GET_ALL_FACTUREAVOIR_REQUEST,
  GET_ALL_FACTUREAVOIR_SUCCESS,
  GET_ALL_FACTUREAVOIR_FAIL,
  ADD_FACTUREAVOIR_REQUEST,
  ADD_FACTUREAVOIR_SUCCESS,
  ADD_FACTUREAVOIR_FAIL,
  GET_FACTUREAVOIR_REQUEST,
  GET_FACTUREAVOIR_SUCCESS,
  GET_FACTUREAVOIR_FAIL,
  UPDATE_FACTUREAVOIR_REQUEST,
  UPDATE_FACTUREAVOIR_SUCCESS,
  UPDATE_FACTUREAVOIR_FAIL,
  DELETE_FACTUREAVOIR_REQUEST,
  DELETE_FACTUREAVOIR_SUCCESS,
  DELETE_FACTUREAVOIR_FAIL,
  ADD_FATCAVARTICLE_REQUEST,
  ADD_FATCAVARTICLE_SUCCESS,
  ADD_FATCAVARTICLE_FAIL,
  UPDATE_FATCAVARTICLE_REQUEST,
  UPDATE_FATCAVARTICLE_SUCCESS,
  UPDATE_FATCAVARTICLE_FAIL,
  DELETE_FATCAVARTICLE_REQUEST,
  DELETE_FATCAVARTICLE_SUCCESS,
  DELETE_FATCAVARTICLE_FAIL
} = require("../../actionTypes/Achat/FactureAvoir");

function getAllFactureAvoirs(state = { data: {} }, action) {
  switch (action.type) {
    case GET_ALL_FACTUREAVOIR_REQUEST:
      return { loading: true, data: {} };
    case GET_ALL_FACTUREAVOIR_SUCCESS:
      return { loading: false, data: action.payload };
    case GET_ALL_FACTUREAVOIR_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function getFactureAvoir(state = { data: {} }, action) {
  switch (action.type) {
    case GET_FACTUREAVOIR_REQUEST:
      return { loading: true, data: {} };
    case GET_FACTUREAVOIR_SUCCESS:
      return { loading: false, data: action.payload };
    case GET_FACTUREAVOIR_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function addFactureAvoir(state = { data: {} }, action) {
  switch (action.type) {
    case ADD_FACTUREAVOIR_REQUEST:
      return { loading: true, data: {} };
    case ADD_FACTUREAVOIR_SUCCESS:
      return { loading: false, data: action.payload };
    case ADD_FACTUREAVOIR_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function updateFactureAvoir(state = { data: {} }, action) {
  switch (action.type) {
    case UPDATE_FACTUREAVOIR_REQUEST:
      return { loading: true, data: {} };
    case UPDATE_FACTUREAVOIR_SUCCESS:
      return { loading: false, data: action.payload };
    case UPDATE_FACTUREAVOIR_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function deleteFactureAvoir(state = { data: {} }, action) {
  switch (action.type) {
    case DELETE_FACTUREAVOIR_REQUEST:
      return { loading: true, data: {} };
    case DELETE_FACTUREAVOIR_SUCCESS:
      return { loading: false, data: action.payload };
    case DELETE_FACTUREAVOIR_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function addArticleFactAvoir(state = { data: {} }, action) {
  switch (action.type) {
    case ADD_FATCAVARTICLE_REQUEST:
      return { loading: true, data: {} };
    case ADD_FATCAVARTICLE_SUCCESS:
      return { loading: false, data: action.payload };
    case ADD_FATCAVARTICLE_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function updateArticleFactAvoir(state = { data: {} }, action) {
  switch (action.type) {
    case UPDATE_FATCAVARTICLE_REQUEST:
      return { loading: true, data: {} };
    case UPDATE_FATCAVARTICLE_SUCCESS:
      return { loading: false, data: action.payload };
    case UPDATE_FATCAVARTICLE_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function deleteArticleFactAvoir(state = { data: {} }, action) {
  switch (action.type) {
    case DELETE_FATCAVARTICLE_REQUEST:
      return { loading: true, data: {} };
    case DELETE_FATCAVARTICLE_SUCCESS:
      return { loading: false, data: action.payload };
    case DELETE_FATCAVARTICLE_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

export {
  addFactureAvoir,
  getFactureAvoir,
  updateFactureAvoir,
  deleteFactureAvoir,
  getAllFactureAvoirs,
  addArticleFactAvoir,
  updateArticleFactAvoir,
  deleteArticleFactAvoir
};
